
export const data = [
    {
        id: 1,
        driverID: '#HT001',
        carbrandAndModel: {
            details: [
                {
                    brand: 'Mercedes Benz',
                    model: 'S400',
                    carNumber: 'FZ-G2005'
                }
            ]
        },
        driverName: {
            details: [
                {
                    name: 'John David',
                    contactNumber: '+65 6878 7876 98',
                }
            ]
        },

        seatCapacity: {
            details: [
                {
                    totalSeat: 4,
                    babySeat: 'Yes'
                }
            ]
        },
        servicePrice: {
            details: [
                {
                    price: '$180.00',
                    fromLocation: 'Singapore Disposal',
                    toLocation: 'Malaysia Disposal',
                    fromDisposal: '$180.00',
                    toDisposal: '$215.00'
                }
            ]
        },
        extraPrice: {
            details: [
                {
                    extraStopSurcharge: '$ 15.00',
                    midnightSurcharge: '$ 15.00',
                    waitingTime: '$15.00'
                }
            ]
        },
        emailAddress: 'raj198672@gmail.com',
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success',
        address: [
            '1 North Bridge Road,',
            '#01-02 , High Street Centre,',
            'Singapore - 179094'
        
        ]
    },
    {
        id: 2,
        driverID: '#HT002',
        carbrandAndModel: {
            details: [
                {
                    brand: 'Mercedes Benz',
                    model: 'S400',
                    carNumber: 'FZ-G2005'
                }
            ]
        },
        driverName: {
            details: [
                {
                    name: 'John David',
                    contactNumber: '+65 6878 7876 98',
                }
            ]
        },


        seatCapacity: {
            details: [
                {
                    totalSeat: 4,
                    babySeat: 'Yes'
                }
            ]
        },
        servicePrice: {
            details: [
                {
                    price: '$180.00',
                    fromLocation: 'Singapore Disposal',
                    toLocation: 'Malaysia Disposal',
                    fromDisposal: '$180.00',
                    toDisposal: '$215.00'
                }
            ]
        },
        extraPrice: {
            details: [
                {
                    extraStopSurcharge: '$ 15.00',
                    midnightSurcharge: '$ 15.00',
                    waitingTime: '$15.00'
                }
            ]
        },
        emailAddress: 'raj198672@gmail.com',
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success',
        address: [
            '1 North Bridge Road,',
            '#01-02 , High Street Centre,',
            'Singapore - 179094'
        
        ]
    },
    {
        id: 3,
        driverID: '#HT003',
        carbrandAndModel: {
            details: [
                {
                    brand: 'Mercedes Benz',
                    model: 'S400',
                    carNumber: 'FZ-G2005'
                }
            ]
        },
        driverName: {
            details: [
                {
                    name: 'John David',
                    contactNumber: '+65 6878 7876 98',
                }
            ]
        },


        seatCapacity: {
            details: [
                {
                    totalSeat: 4,
                    babySeat: 'Yes'
                }
            ]
        },
        servicePrice: {
            details: [
                {
                    price: '$180.00',
                    fromLocation: 'Singapore Disposal',
                    toLocation: 'Malaysia Disposal',
                    fromDisposal: '$180.00',
                    toDisposal: '$215.00'
                }
            ]
        },
        extraPrice: {
            details: [
                {
                    extraStopSurcharge: '$ 15.00',
                    midnightSurcharge: '$ 15.00',
                    waitingTime: '$15.00'
                }
            ]
        },
        emailAddress: 'raj198672@gmail.com',
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'In-Active',
        statusColor: 'danger',
        address: [
            '1 North Bridge Road,',
            '#01-02 , High Street Centre,',
            'Singapore - 179094'
        
        ]
    },
    {
        id: 4,
        driverID: '#HT004',
        carbrandAndModel: {
            details: [
                {
                    brand: 'Mercedes Benz',
                    model: 'S400',
                    carNumber: 'FZ-G2005'
                }
            ]
        },
        driverName: {
            details: [
                {
                    name: 'John David',
                    contactNumber: '+65 6878 7876 98',
                }
            ]
        },


        seatCapacity: {
            details: [
                {
                    totalSeat: 4,
                    babySeat: 'Yes'
                }
            ]
        },
        servicePrice: {
            details: [
                {
                    price: '$180.00',
                    fromLocation: 'Singapore Disposal',
                    toLocation: 'Malaysia Disposal',
                    fromDisposal: '$180.00',
                    toDisposal: '$215.00'
                }
            ]
        },
        extraPrice: {
            details: [
                {
                    extraStopSurcharge: '$ 15.00',
                    midnightSurcharge: '$ 15.00',
                    waitingTime: '$15.00'
                }
            ]
        },
        emailAddress: 'raj198672@gmail.com',
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success',
        address: [
            '1 North Bridge Road,',
            '#01-02 , High Street Centre,',
            'Singapore - 179094'
        
        ]
    },
    {
        id: 5,
        driverID: '#HT005',
        carbrandAndModel: {
            details: [
                {
                    brand: 'Mercedes Benz',
                    model: 'S400',
                    carNumber: 'FZ-G2005'
                }
            ]
        },
        driverName: {
            details: [
                {
                    name: 'John David',
                    contactNumber: '+65 6878 7876 98',
                }
            ]
        },


        seatCapacity: {
            details: [
                {
                    totalSeat: 4,
                    babySeat: 'Yes'
                }
            ]
        },
        servicePrice: {
            details: [
                {
                    price: '$180.00',
                    fromLocation: 'Singapore Disposal',
                    toLocation: 'Malaysia Disposal',
                    fromDisposal: '$180.00',
                    toDisposal: '$215.00'
                }
            ]
        },
        extraPrice: {
            details: [
                {
                    extraStopSurcharge: '$ 15.00',
                    midnightSurcharge: '$ 15.00',
                    waitingTime: '$15.00'
                }
            ]
        },
        emailAddress: 'raj198672@gmail.com',
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'In-Active',
        statusColor: 'danger',
        address: [
            '1 North Bridge Road,',
            '#01-02 , High Street Centre,',
            'Singapore - 179094'
        
        ]
    },
    {
        id: 6,
        driverID: '#HT006',
        carbrandAndModel: {
            details: [
                {
                    brand: 'Mercedes Benz',
                    model: 'S400',
                    carNumber: 'FZ-G2005'
                }
            ]
        },
        driverName: {
            details: [
                {
                    name: 'John David',
                    contactNumber: '+65 6878 7876 98',
                }
            ]
        },


        seatCapacity: {
            details: [
                {
                    totalSeat: 4,
                    babySeat: 'Yes'
                }
            ]
        },
        servicePrice: {
            details: [
                {
                    price: '$180.00',
                    fromLocation: 'Singapore Disposal',
                    toLocation: 'Malaysia Disposal',
                    fromDisposal: '$180.00',
                    toDisposal: '$215.00'
                }
            ]
        },
        extraPrice: {
            details: [
                {
                    extraStopSurcharge: '$ 15.00',
                    midnightSurcharge: '$ 15.00',
                    waitingTime: '$15.00'
                }
            ]
        },
        emailAddress: 'raj198672@gmail.com',
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'In-Active',
        statusColor: 'danger',
        address: [
            '1 North Bridge Road,',
            '#01-02 , High Street Centre,',
            'Singapore - 179094'
        
        ]
    }

]

export const carBrandList = [
    {
        options: [
            { label: "Select Car Brand", value: "Select Car Brand" , isDisabled: true },
            { label: "Combi (13- seater)", value: "Combi (13- seater)" },
            { label: "Mercedes Benz S400", value: "Mercedes Benz S400" },
            { label: "MPV", value: "MPV" },
            { label: "Toyota Alphard Hybrid", value: "Toyota Alphard Hybrid" },
        ]
    }
]
export const cityList = [
    {
        options: [
            { label: "Select City", value: "Select City",isDisabled: true },
            { label: "Aljunied", value: "Aljunied" },
            { label: "East Coast", value: "East Coast" },
            { label: "Hong Kah", value: "Hong Kah" },
            { label: "Jalan Besar", value: "Jalan Besar" },
        ]
    }
]
export const countryList = [
    {
        options: [
            { label: "Select Country", value: "Select Country", isDisabled: true },
            { label: "Singapore", value: "Singapore" },
            { label: "Malasiya", value: "Malasiya" },
            { label: "India", value: "India" },
            { label: "America", value: "America" },
        ]
    }
]